const StringProperties = {
    "Octopus.Action.Package.JsonConfigurationVariablesTargets": "",
    "Octopus.Action.EnabledFeatures": "",
};

export type StructuredConfigurationProperties = { [P in keyof typeof StringProperties]: string };
